import { Skeleton } from "@gerama/ui";

export function ArtistDetailSkeleton() {
  return (
    <div className="space-y-8">
      <div className="flex flex-col items-center gap-6 sm:flex-row sm:items-end">
        <Skeleton className="size-56 rounded-full" />
        <div className="space-y-3">
          <Skeleton className="h-5 w-24" />
          <Skeleton className="h-14 w-72" />
          <Skeleton className="h-4 w-56" />
        </div>
      </div>
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
